export default __webpack_public_path__ + "static/media/localizador2.0b082ed1.png";